module.exports = __webpack_public_path__ + "img/play_icon.229db15e.png";